import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 items-center justify-center px-4 py-20">
        <div className="flex max-w-lg flex-col items-center text-center">
          <span className="font-heading text-6xl font-bold text-primary-500">404</span>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
            这块瓜田还没开垦
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            你访问的页面可能已经下架，或者链接不太对。不如回首页，看看今天大家都在聊什么。
          </p>
          <p className="mt-2 text-xs text-foreground-400">{location.pathname}</p>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-home-4-line text-base" />
              </span>
              返回首页
            </Link>
            <Link
              to="/about"
              className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              了解黑瓜吃料
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}